import { Spinner, Text } from '@viapeople/components'
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'

interface GoalCompletionRow {
	department: string
	avgCompletionPercent: number
	userCount: number
}

interface Props {
	data: GoalCompletionRow[] | undefined
	loading?: boolean
}

export function GoalCompletionByDepartmentChart({ data, loading }: Props) {
	if (loading) {
		return (
			<div data-testid='goal-completion-by-dept-loading' className='flex items-center justify-center h-64'>
				<Spinner />
			</div>
		)
	}
	if (!data || data.length === 0) {
		return (
			<div
				data-testid='goal-completion-by-dept-empty'
				className='flex items-center justify-center h-64 text-neutral-500'>
				No goal data available for the current filters.
			</div>
		)
	}

	return (
		<div data-testid='goal-completion-by-dept-chart' className='w-full'>
			<Text variant='small' weight='semibold' className='mb-2'>
				Goal Completion % by Department
			</Text>
			<ResponsiveContainer width='100%' height={300}>
				<BarChart data={data} layout='vertical' margin={{ top: 16, right: 24, left: 64, bottom: 24 }}>
					<CartesianGrid strokeDasharray='3 3' stroke='#e5e7eb' />
					<XAxis type='number' domain={[0, 100]} tick={{ fontSize: 12 }} />
					<YAxis dataKey='department' type='category' tick={{ fontSize: 12 }} width={120} />
					<Tooltip
						contentStyle={{ fontSize: 12, borderRadius: 6, border: '1px solid #e5e7eb' }}
						formatter={(value: number | undefined) => (value != null ? `${value.toFixed(1)}%` : '-')}
					/>
					<Bar dataKey='avgCompletionPercent' fill='#0ea5e9' name='Avg Goal Completion %' radius={[0, 2, 2, 0]} />
				</BarChart>
			</ResponsiveContainer>
		</div>
	)
}
